import { useTranslation } from 'react-i18next'
import './LPVideo.css'

function LPVideo() {

    const { t } = useTranslation()

    return (
        <>

            <div className='container-lg p-0 d-flex flex-column justify-content-center align-items-center lpvideocontainer'>
                <section className="container-lg p-0 d-flex justify-content-between align-items-center">
                    <h2 className='heading text-center w-100'>{t("hrs.videotext")}</h2>
                </section>

                
                <video controls className='mt-5' muted loop autoplay
                poster='videos/zamekfilm1.mp4'>
                    <source src="videos/zamekfilm1.webm" type="video/webm" />
                    <source src="videos/zamekfilm1.mp4" type="video/mp4" />
                </video>
            

            </div>
        </>
    )
}


export default LPVideo